import React from 'react'
import {Link} from 'react-router-dom'

import {useLocale} from '../../hocs/hooks'
import hostVoice1 from '../../../assets/imgs/host/host-voice1.png'
import hostVoice2 from '../../../assets/imgs/host/host-voice2.png'
import hostVoice3 from '../../../assets/imgs/host/host-voice3.png'
import ResponsiveImg from '../../common/ResponsiveImg'
import LocaleText from '../../common/LocaleText'
import styles from './HostVoice.scss'

const HostVoice = () => {
  const locale = useLocale()
  return <>
    <div className={[styles.container].join(' ')}>
      <div className={[styles.space120].join(' ')} />
      <div className={['font-weight-bold text-center', styles.subTitle].join(' ')}>
        ホスト体験談
      </div>
      <div className={['d-flex justify-content-between row m-0'].join(' ')}>
        <div className={['d-flex align-items-center flex-column', styles.cardContainer].join(' ')}>
          <Link to={`/${locale}/media/interview/5fc04557d1a489681cab255a/`} className={['d-flex flex-column flex-md-row justify-content-around no-gutters', styles.card].join(' ')}>
            <div>
              <div>
                <ResponsiveImg
                  url={hostVoice1}
                  caption={hostVoice1}
                />
              </div>
              <div className={styles.p24}>
                <div className={[styles.title, styles.mb13].join(' ')}>
                  団体向けだった駐車場を車中泊スポットに活用！「一条竹の子村」ホストの清水さんがもつ、ゲストへの想い
                </div>
                <div className={styles.text}>
                  <span>清水さん｜</span>
                  <span>静岡県｜</span>
                  <span>一条竹の子村運営</span>
                </div>
                <div className={[styles.textContent].join(' ')}>
                  南伊豆の静かな山にあるCarstayステーション「一条竹の子村」は、南伊豆観光をする車中泊拠点としてアクセス抜群！自然の恵みがあふ...
                  <span className={[styles.textContent, styles.fw6].join(' ')}>体験談を読む</span>
                </div>
              </div>
            </div>
          </Link>
        </div>


        <div className={['d-flex align-items-center flex-column', styles.cardContainer].join(' ')}>
          <Link to={`/${locale}/media/interview/inakabackpacker/`} className={['d-flex flex-column flex-md-row justify-content-around no-gutters', styles.card].join(' ')}>
            <div>
              <div>
                <ResponsiveImg
                  url={hostVoice2}
                  caption={hostVoice2}
                />
              </div>
              <div className={styles.p24}>
                <div className={[styles.title, styles.mb13Sp].join(' ')}>
                  「泊まれる駐車場」作った理由とは？バンライファー中川生馬さんの想い
                </div>
                <div className={styles.text}>
                  <span>イクさん｜</span>
                  <span>石川県｜</span>
                  <span>田舎バックパッカーハウス運営</span>
                </div>
                <div className={[styles.textContent2].join(' ')}>
                  能登半島の港町で「泊まれる駐車場」をキャッチコピーとする宿を見つけました。その名も「田舎バックパッカーハウス」（石川県穴水町）...
                  <span className={[styles.textContent, styles.fw6].join(' ')}>体験談を読む</span>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className={['d-flex align-items-center flex-column', styles.cardContainer].join(' ')}>
          <Link to={`/${locale}/media/interview/5fae030bf431eb2f702cad40/`} className={['d-flex flex-column flex-md-row justify-content-around no-gutters', styles.card].join(' ')}>
            <div>
              <div>
                <ResponsiveImg
                  url={hostVoice3}
                  caption={hostVoice3}
                />
              </div>
              <div className={styles.p24}>
                <div className={[styles.title, styles.mb13].join(' ')}>
                  Carstayステーションに登録したきっかけは何？RVステーション「南伊豆さくら」のホストにインタビュー
                </div>
                <div className={styles.text}>
                  <span>高田さん｜</span>
                  <span>静岡県｜</span>
                  <span>南伊豆さくら運営</span>
                </div>
                <div className={[styles.textContent].join(' ')}>
                  南伊豆でCarstayステーション「RVステーション南伊豆さくら」のホストをされている高田昭子さん。Carstayのステーションサービスが始...
                  <span className={[styles.textContent, styles.fw6].join(' ')}>体験談を読む</span>
                </div>
              </div>
            </div>
          </Link>
        </div>

      </div>

      <div className={['d-flex align-items-center justify-content-center', styles.buttonView].join(' ')}>
        <Link to={`/${locale}/media/keyword/%E3%83%9B%E3%82%B9%E3%83%88%E3%82%A4%E3%83%B3%E3%82%BF%E3%83%93%E3%83%A5%E3%83%BC/`}
          className={['btn border bg-white d-flex justify-content-center align-items-center', styles.button].join(' ')}>
          <div className={['d-flex justify-content-center text-black', styles.text, styles.buttonText].join(' ')}>
            <LocaleText ja="すべての記事を見る" en="See all posts"/>
          </div>
        </Link>
      </div>

    </div>
    <div className={styles.space121}/>
  </>
}
HostVoice.displayName = 'HostVoice'
export default HostVoice
